<template>
  <div class="section">
    <div class="container">
      <h1>Subscriptions</h1>
      <br />
      <div class="column is-3">
        <b-input v-model="filter" placeholder="Filter Subscriptions"></b-input>
      </div>
      <br />
      <div class="columns">
        <div class="column">
          <subscriptions :loading="loading" :data="filteredSubscriptions" Admin></subscriptions>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import subscriptionComponent from "@/components/user/paymentDetails/subscriptions";
  export default {
    data() {
      return {
        loading: true,
        subscriptions: [],
        user: {},
        filter: ''
      }
    },
    components: {
      "subscriptions": subscriptionComponent
    },
    computed: {
      filteredSubscriptions() {
        return this.subscriptions.filter((option) => {
          if (option.Name.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
            return true;
          }
          if (option.Organization && option.Organization.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
            return true;
          }
          if (option.UserName.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
            return true;
          }
        });
      }
    },
    methods: {
      async GetPaymentDetails() {
        try {
          var response = await this.$http.get("/api/user/paymentDetails/admin");
          this.subscriptions = response.data.Subscriptions;
        }
        catch (err) {
          this.error = true;
          console.error(err);
        }
      },
    },
    async mounted() {
      await this.GetPaymentDetails();
      this.loading = false;
    }
  }

</script>
